import React, {Fragment} from 'react'

const BlockStyleFive = () => {
    return (
      <Fragment>
        <div className="block-style-five ps-xxl-5 ms-xxl-4">
          <h6 className="sub-title mb-20" data-aos="fade-up">
            Latest Videos
          </h6>
          <h3 className="sect-title mb-20">
            The Best Software Development Agency
          </h3>
          <p className="pe-xxl-5 mb-55">
            Continuously develop standards-compliant strategies instead of
            focusing solely on performance-driven approaches. Leverage
            alternative global solutions by engaging virtual users effectively.
          </p>
        </div>
      </Fragment>
    );
}

export default BlockStyleFive